module.exports = __webpack_public_path__ + "img/senegal.9ba2a6a0.png";